import isEmpty from 'lodash/isEmpty'
import { useRouter } from 'next/router'
import { FilteredItem } from './filtered-item'

import {
  Box,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  Flex,
  SimpleGrid,
  Spinner,
  Text
} from '@chakra-ui/react'
import CategoryFilters from '@components/category-filters'
import { IoArrowBack } from 'react-icons/io5'

interface ShopFilterProps {
  shopId: string
  isDrawerOpen: boolean
  onDrawerClose: () => void
  numberOfProductsFound: number | undefined
}

export const FiltersDrawer = ({
  shopId,
  isDrawerOpen,
  onDrawerClose,
  numberOfProductsFound,
}: ShopFilterProps) => {
  const router = useRouter()
  const { pathname, query } = router
  return (
    <>
      <Flex
        direction="column"
        display={{ base: 'none', lg: 'flex' }}
        pt="2"
        position="sticky"
      >
        {!isEmpty(query) && (
          <>
            <Flex mb="2" justify="space-between">
              <Text>Tags</Text>
              <Text
                fontSize="13px"
                color="blackAlpha.600"
                cursor="pointer"
                transition="all"
                _hover={{ color: 'black' }}
                onClick={() => {
                  router.push(pathname)
                }}
              >
                Clear all
              </Text>
            </Flex>

            <Flex gap="2" align="left" flexWrap="wrap" mb="4">
              {Object.values(query)
                .join(',')
                .split(',')
                .map(
                  (v, idx) =>
                    !isEmpty(v) && (
                      <FilteredItem
                        itemKey={
                          Object.keys(query).find((k) => query[k]?.includes(v))!
                        }
                        itemValue={v}
                        key={idx}
                      />
                    ),
                )}
            </Flex>
          </>
        )}

        <CategoryFilters
          shopId={shopId}
          display={{ base: 'none', lg: 'block' }}
        />
      </Flex>

      <Drawer placement="left" onClose={onDrawerClose} isOpen={isDrawerOpen}>
        <DrawerOverlay />
        <DrawerContent display={{ base: 'flex', lg: 'none' }}>
          <DrawerHeader borderBottomWidth="1px">
            <SimpleGrid columns={3} alignItems="center">
              <IoArrowBack
                className="text-skin-base"
                fontSize="20px"
                onClick={onDrawerClose}
              />
              <Text fontWeight="700" fontSize="20px" textAlign="center">
                Tags
              </Text>
            </SimpleGrid>
          </DrawerHeader>
          <DrawerBody>
            <Flex direction="column" pt="2" position="sticky">
              {!isEmpty(query) && (
                <>
                  <Flex mb="2" justify="space-between">
                    <Text>Tags</Text>
                    <Text
                      fontSize="13px"
                      color="blackAlpha.600"
                      cursor="pointer"
                      transition="all"
                      _hover={{ color: 'black' }}
                      onClick={() => {
                        router.push(pathname)
                      }}
                    >
                      Clear all
                    </Text>
                  </Flex>

                  <Flex gap="2" align="left" flexWrap="wrap" mb="4">
                    {Object.values(query)
                      .join(',')
                      .split(',')
                      .map(
                        (v, idx) =>
                          !isEmpty(v) && (
                            <FilteredItem
                              itemKey={
                                Object.keys(query).find((k) =>
                                  query[k]?.includes(v),
                                )!
                              }
                              itemValue={v}
                              key={idx}
                            />
                          ),
                      )}
                  </Flex>
                </>
              )}
            </Flex>
            <CategoryFilters shopId={shopId} />
          </DrawerBody>
          <DrawerFooter justifyContent="center">
            <Box px="3">
              {numberOfProductsFound !== undefined ? (
                <Text fontWeight="500" fontSize="20px">
                  {numberOfProductsFound} Item
                  {numberOfProductsFound > 1 ? 's' : ''} Found
                </Text>
              ) : (
                <Spinner />
              )}
            </Box>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </>
  )
}
